import { Stack } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import InvestorCommunicationContentForm from "./InvestorCommunicationContentForm";
import InvestorCommunicationSavedContentPreview from "./InvestorCommunicationSavedContentPreview";

const InvestorCommunicationContentTab = () => {
  const { hasEditPermissions } = useDefinedContext(InvestorCommunicationContext, "InvestorCommunicationContext");

  if (hasEditPermissions) {
    return (
      <Stack sx={{ flex: 1, py: 2.5 }}>
        <InvestorCommunicationContentForm />
      </Stack>
    );
  }

  return <InvestorCommunicationSavedContentPreview />;
};

export default InvestorCommunicationContentTab;
